export default __webpack_public_path__ + "static/media/ic-more-blue-24-px.07130f38.svg";